<template>
  <div>
    <label
      v-if="label"
      :for="name"
      class="mb-1 block text-xs font-medium text-background-fg/70"
    >
      {{ label }}
    </label>
    <div
      class="flex flex-row flex-nowrap justify-between space-x-1"
    >
      <template
        v-for="option in colorOptions"
        :key="option"
      >
        <button
          class="flex size-6 items-center justify-center rounded p-px"
          :style="{ backgroundColor: option }"
          type="button"
          @click="setColor(option)"
        >
          <template v-if="option === value">
            <IconDot class="size-full text-background" />
          </template>
        </button>
      </template>
      <button
        class="flex size-6 items-center justify-center rounded bg-background-fg/30 p-0.5"
        type="button"
        @click="setColor(null)"
      >
        <IconX class="size-full text-background" />
      </button>
    </div>
    <p
      v-show="hasError"
      :class="[
        hasError ? 'text-error' : '',
        'mt-2 text-sm',
      ]"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate"

const props = withDefaults(
  defineProps<{
    name: string
    label: string
  }>(),
  {}
)

const name = toRef(props, "name")

const { value, errorMessage } = useField<string | null>(
  name,
  undefined,
  {}
)

const hasError = computed(() => !!errorMessage.value)

const setColor = (color: string | null) => {
  value.value = color
}

const colorOptions = [
  "rgb(var(--color-yellow))",
  "rgb(var(--color-orange)",
  "rgb(var(--color-primary))",
  "rgb(var(--color-teal))",
  "rgb(var(--color-lavender))",
  "rgb(var(--color-sky-blue))",
  "rgb(var(--color-mint))",
  "rgb(var(--color-light-blue))",
  "rgb(var(--color-cool-grey))",
  "rgb(var(--color-slate-grey))",
]
</script>
